import {
  ImportedItemRow,
  ImportedItemValidationResult,
  ImportedItemValidatorObject,
  ImportFormatItem,
} from '../../../../lib/imports/importTypes';
import { EntityListProductInputData } from './entityListTypes';

/**
 * Rows may contain duplicate data which is rows with the same product, source and target store identifiers.
 * This validator marks rows that are such duplicates.
 * @param rows
 * @param identificationKeys keys that should be used to identify the row
 */
export class DuplicateItemsValidator<
  T extends EntityListProductInputData,
> implements ImportedItemValidatorObject<T> {
  private keyMap: Record<string, number> = {};

  constructor(private uniqueItems: ImportFormatItem<T>[]) {}

  validate(item: ImportedItemRow<T>): ImportedItemValidationResult {
    const rowKey = this.getRowKey(item);
    if (this.keyMap[rowKey]) {
      return [`Is duplicate to row ${this.keyMap[rowKey]}`];
    } else {
      this.keyMap[rowKey] = item.rowNumber;
    }
  }

  getRowKey(item: ImportedItemRow<T>): string {
    return this.uniqueItems
      .map(formatItem => {
        if (formatItem.id in item.inputData) {
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions -- we want to convert to string
          return `${item.inputData[formatItem.id]}`;
        } else {
          return '';
        }
      })
      .filter(part => part.length > 0)
      .join('-');
  }

  reset(): void {
    this.keyMap = {};
  }
}
